import React, { useState, useEffect } from "react";
import { notificarError } from "../Almacenes/AlmacenNotify";
import UbigeoSelector from "./UbigeoSelector";


function FindCompany({ subtitle, onChange }) {
    const [ruc, setRuc] = useState('');
    const [company, setCompany] = useState(null);
    const [ubigeo, setUbigeo] = useState(null);
    const [address, setAddress] = useState("");

    useEffect(() => {
        if (!company || !ubigeo || !address) {
            return;
        }

        onChange && onChange({ ruc, name: company.name, ubigeo, address });
    }, [company, ubigeo, address, onChange]);

    const handleSearch = (ruc) => {

        const rucValido = (/^(10|20)\d{9}$/.test(ruc) || /^\d{8}$/.test(ruc));

        if (!rucValido) {
            notificarError('El número de documento ingresado no es válido. Debe ser un RUC de 11 dígitos o un DNI de 8 dígitos.');

            return;
        }

        fetchCompany(ruc);
    }

    const fetchCompany = async (ruc) => {
        reset();


        const docType = ruc.length === 11 ? 'ruc' : 'dni';

        const req = await fetch(`https://prorucdni.mifacturaperu.com/documentos/buscar/${docType}/${ruc}`, {

            headers: {
                "Authorization": `Bearer 60e5b0d7bd24e8fa2dcefa1bf3550f6b020c0948`
            }
        });

        if (!req.ok) {

            notificarError('No se encontró la empresa con el RUC o DNI ingresado.');

            return;
        }

        const data = await req.json();
        setCompany(data);

        if (data.address) {
            setAddress(data.address);
        }
    }

    const reset = () => {
        setCompany(null);
        setUbigeo(null);
        setAddress('');
    }

    return <>
        {
            subtitle && (
                <div className="col-12">
                    <h4 className="font-weight-bold h6 text-uppercase">{subtitle}</h4>
                </div>
            )
        }
        <div className="caja-fondo-blanco-m-2 p-4 container-fluid">
            <div className="row">
                <div className="col-12 col-md-4 col-lg-3">
                    <div className="form-group">

                        <label htmlFor="companyName">RUC o DNI</label>

                        <div className="d-flex">
                            <div className="input__Almacen">
                                <input
                                    name="RUC"
                                    className="input__linea"
                                    type="text"
                                    placeholder="RUC"
                                    autoComplete="off"
                                    value={ruc}
                                    onChange={(e) => setRuc(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSearch(ruc);
                                        }
                                    }}
                                />
                            </div>
                            <button className="btn btn-verde-mfp-letra-normal rounded-0" onClick={() => handleSearch(ruc)}>
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-8 col-lg-9">
                    <div className="form-group">
                        <label htmlFor="companyName">Razón Social</label>
                        <div className="input__Almacen">
                            <input name="RazonSocial" className="input__linea" type="text" disabled value={company?.name} />
                        </div>
                    </div>
                </div>
                {
                    company && <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="companyName">Ubigeo</label>
                            <UbigeoSelector initialUbigeo={company?.ubigeo} onChange={(ubigeo) => setUbigeo(ubigeo)} />
                        </div>
                    </div>
                }

                <div className="col-12">
                    <div className="form-group">
                        <label htmlFor="companyName">Dirección</label>
                        <div className="input__Almacen">
                            <input name="Direccion" className="input__linea" type="text" value={address} onChange={(e) => setAddress(e.target.value)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default FindCompany;